// src/utils/typingLessons.js

// Hardcoded default lessons have been removed as per user request.
// All lessons should now be managed through the Typing Tutor Settings (Admin).

export const HINDI_LESSONS = [];

export const ENGLISH_LESSONS = [];
